module.exports = __webpack_public_path__ + "img/lock.dfc35d22.png";